<template>
  <!-- 咨询方案生成订单 -->
  <div v-if="bodyShow" class="xd-consult-order">
    <!--  -->
    <div class="bg"></div>
    <div class="line"></div>
    <div class="line-rgb"></div>
    <!-- 主体内容 -->
    <div class="content">
      <h3>项目</h3>
      <div class="row" v-for="(item,index) in list" :key="index">
        <template v-if="item.name=='服务次数'">
          <div class="frequency">
            <label class="on" for="">{{item.name}}</label>
            <img src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/xd-close-on.png" alt="">
            <span class="on">{{item.val}}</span>
          </div>
        </template>
        <template v-else>
          <label for="">{{item.name}}</label>
          <img src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/xd-close.png" alt="">
          <span>{{item.val}}</span>
        </template>
      </div>
      <!--  -->
      <!-- price -->
      <div class="price">
        <label for="">应付款：</label>
        <div class="pri">¥{{itemOrder.price/100}}</div>
      </div>
    </div>
    <!--  -->
    <div class="footer">
      <button @click="goBackHandle()">返回调整方案</button>
      <button class="on" @click="shareBool=true">分享</button>
    </div>
    <!-- share bg  分享背景 -->
    <div v-if="shareBool" class="share-bg" @click="shareBool=false">
      <img @click="shareBool=false" src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/share_bg.png" alt="">
    </div>
  </div>
</template>

<script>
import { extensionGet,userInfo } from "@/api/xuandui_gadgets";
import { shareCon } from "@/utils/wxconfig";
import { deepCopy } from "@/utils/tools";
export default {
  data() {
    return {
      bodyShow:false,
      list:[],
      itemOrder:{},
      shareBool:false
    }
  },
  methods: {
    // 返回调整
    goBackHandle(){
      let q = this.$route.query;
      if(!this.itemOrder.id && !q.id){
        this.$toast('方案ID不存在！');
        return
      }
      this.$router.push({
        path:'/xd_consult_plan',
        query:{
          id:this.itemOrder.id || q.id
        }
      });
    },
    // 初始化获取数据
    pullData() {
      let q = this.$route.query;
      if(!q.id){
        this.$toast('方案ID不能为空！');
        return
      }
      //调用加载中
      this.$emit("loadingHandle", true, "获取方案中...");
      document.title = '咨询方案';
      extensionGet({
        id:q.id
      }).then((data)=>{
        //关闭加载中
        this.$emit("loadingHandle", false);
        if(data.error>0){
            this.$toast(data.msg);
            return
        }
        this.itemOrder = data.item;
        if(data.item.detail && JSON.parse(data.item.detail)){
          let obj = JSON.parse(data.item.detail);
          let keys = Object.keys(JSON.parse(data.item.detail));
          let array = [];
          keys.map(v=>{
            array.push({
              name:v,
              val:obj[v]
            });
          });
          this.list = array;
        }
        this.bodyShow = true;
        let shareConObj = {
          eid:q.id,
          name:'商品B-2次'
        };
        shareCon("xuandui_order", this,shareConObj);

      });
      
    },
  },
  created() {
    this.pullData();
  },
};
</script>
<style lang="scss">
    body{
        background-color: #ffffff;
    }
</style>
<style lang="scss" scoped>
.xd-consult-order {
  padding-bottom: 120px;
  .bg{
    width: 100%;
    height: 184px;
    background: #46A3FA;
  }
  .line{
    margin: -108px auto 0;
    width: 710px;
    height: 24px;
    background: #128DFF;
    border-radius: 16px;
  }
  .line-rgb{
    position: relative;
    z-index: 2;
    margin: -20px auto 0;
    width: 710px;
    height: 24px;
    background: #128DFF;
    border-radius: 16px;
    opacity: 0.26;
    filter: blur(4px);
  }
  .content{
    width: 690px;
    margin: -16px auto 0;
    background-color: #ffffff;
    border-radius: 0px 0px 20px 20px;
    padding: 40px 30px 30px;
    h3{
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #2B333A;
      line-height: 46px;
    }
    .row{
      display: flex;
      align-items: center;
      height: 98px;
      label{
        margin-right: auto;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #7C828A;
        line-height: 46px;
      }
      img{
        width: 24px;
      }
      span{
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #7C828A;
        line-height: 40px;
      }
      .frequency{
        flex: 1;
        display: flex;
        align-items: center;
        margin: 32px auto 34px;
        label.on{
          margin-right: auto;
          font-size: 30px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #2B333A;
          line-height: 46px;
        }
        img{
          width: 24px;
        }
        span.on{
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2B333A;
          line-height: 40px;
        }
      }
    }
    
    .price{
      display: flex;
      align-items: center;
      justify-content: flex-end;
      label{
        margin-right: 0;
        font-size: 30px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #2B333A;
        line-height: 42px;
      }
      .pri{
        height: auto;
        font-size: 36px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color:#FF2300;
        line-height: 42px;
      }
    }
  }
  .footer {
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    max-width: 750px;
    background-color: #ffffff;
    button {
      width: 314px;
      height: 88px;
      background: #F7F8F9;
      border-radius: 44px;
      font-size: 32px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #7F848C;
      line-height: 44px;
      letter-spacing: 1px;
      border: none;
      &:first-child{
        margin-right: 42px;
      }
    }
    button.on{
      color: #FFFFFF;
      background: #46A3FA;
      border-radius: 44px;
    }
  }
  // 分享背景
  .share-bg{
    position: fixed;
    max-width: 750px;
    width: 100%;
    height: 100%;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 998;
    img{
      width: 100%;
    }
  }
}
</style>